import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { NON_BORROWER_ENTITIES_ACTION_TYPE } from '../actions';

const initialState = {};

const nonBorrowerEntitiesReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case NON_BORROWER_ENTITIES_ACTION_TYPE.CREATE_ENTITY:
        draft[payload.nonBorrowerEntityId] = payload;
        break;

      case NON_BORROWER_ENTITIES_ACTION_TYPE.DELETE_ENTITY:
        delete draft[meta.nonBorrowerEntityId];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default nonBorrowerEntitiesReducer;
